import React from 'react';
import { Routes, Route, Navigate, BrowserRouter, useLocation, Outlet, useNavigate } from "react-router-dom";
import Login from "./Login";
import {useSelector} from "react-redux";
import {State} from "./state/store";
import GlobalNav from "./nav/GlobalNav";
import Footer from "./Footer";
import Logout from "./Logout";
import CalendarContainer from "./calendar/Container";
import ManageContainer from "./manage/Container";
import EventsReport from "./reports/events/EventsReport";
import {Alert, Stack} from "@mui/material";
import {addMinutes} from "date-fns";
import parseISODate from "date-fns/parseISO";
import {envType} from "./context/environment";
import NotificationsContainer from "./notifications/NotificationsContainer";
import SubscriptionsList from "./notifications/events/SubscriptionsList";
import SummariesList from "./notifications/summaries/SummariesList";
import NewSubscription from "./notifications/events/NewSubscription";
import EditSubscription from "./notifications/events/EditSubscription";
import ReportsContainer from "./reports/ReportsContainer";
import ErrorBoundary from "./ErrorBoundary";
import NewSummary from "./notifications/summaries/NewSummary";
import EditSummary from "./notifications/summaries/EditSummary";

export default function AppRoutes() {

	return (
		<BrowserRouter>
			<Routes>
				<Route path="/login" element={<Login />}/>
				<Route path="/logout" element={<Logout />}/>
				<Route path={"/"} element={<AuthedApp />}>
					<Route index element={<CalendarContainer />} />
					<Route path="calendar">
						<Route path=":id" element={<CalendarContainer />} />
						<Route index element={<CalendarContainer />} />
					</Route>
					<Route path="notification">
						<Route path="events/new" element={<NewSubscription />} />
						<Route path="events/:id" element={<EditSubscription />} />
						<Route path="summaries/new" element={<NewSummary />} />
						<Route path="summaries/:id" element={<EditSummary />} />
					</Route>
					<Route path="notifications" element={<NotificationsContainer />}>
						<Route index element={<SubscriptionsList />} />
						<Route path="events" element={<SubscriptionsList />} />
						<Route path="summaries" element={<SummariesList />} />
					</Route>
					<Route path="manage" element={<ManageContainer />} />
					<Route path="reports" element={<ReportsContainer />}>
						<Route index element={<EventsReport />} />
						<Route path="events" element={<EventsReport />} />
					</Route>
				</Route>
			</Routes>
		</BrowserRouter>
	);
}

function AuthedApp() {

	const user = useSelector((s:State) => s.user), navigate = useNavigate();
	const location = useLocation();

	React.useEffect(() => {
		const sessionCheck = () => {
			if (user?.sessionExpires) {
				const now = addMinutes(new Date(), 5);
				const sessionExpires = parseISODate(user.sessionExpires);
				if (now.getTime() > sessionExpires.getTime()) {
					navigate("/logout");
				}
			}
		}
		const checkInterval = setInterval(sessionCheck, 300_000);
		return () => { clearInterval(checkInterval); }
	}, [navigate, user?.sessionExpires]);

	if (!user) {
		return <Navigate to={"/login"} state={{ from: location.pathname }} />;
	}

	return (
		<Stack direction={"row"}>
			<GlobalNav />
			<Stack sx={{ ml: 8, width: "calc(100% - 64px)" }}>
				{envType !== "prod" &&
					<Alert severity="warning" variant={"standard"} square>
						This is a <b>{envType}</b> environment. Some things may not work or be weird. You've been warned.
					</Alert>}
				<ErrorBoundary>
					<Outlet />
				</ErrorBoundary>
				<Footer />
			</Stack>
		</Stack>
	);
}



